import React, { memo, FunctionComponent } from 'react';

import { TranslatedString } from '../locale';

export interface EditLinkProps {
    className?: string;
    url: string;
}

const EditLink: FunctionComponent<EditLinkProps> = ({ className, url }) => {
    // if there is b3 quote checkout, user cant edit cart
    const quoteCheckoutId = localStorage.getItem('quoteCheckoutId')

    if (quoteCheckoutId) {
        return null
    }

    return (
        <a
            className={className || 'cart-header-link'}
            data-test="cart-edit-link"
            href={url}
            id="cart-edit-link"
            target="_top"
        >
            <TranslatedString id="cart.edit_cart_action" />
        </a>
    )
};

export default memo(EditLink);
